import { render, staticRenderFns } from "./News.vue?vue&type=template&id=cbe4378a&scoped=true"
import script from "./News.vue?vue&type=script&lang=ts"
export * from "./News.vue?vue&type=script&lang=ts"
import style0 from "./News.vue?vue&type=style&index=0&id=cbe4378a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbe4378a",
  null
  
)

export default component.exports